import { Federacion, FederacionJSON } from '../Federacion/Federacion';

export interface ClubJSON {
  club_id: string | null;
  club_nombre: string;
  club_direccion: string;
  club_proid: number;
  club_localidad: string;
  club_cod_postal: string;
  club_zona: string;
  club_nro_telefono: string;
  club_activo: boolean;
  club_escudo: string;
  club_cjid_default: number;
  club_fedid: number;
  club_sigla: string | null;
  club_website: string | null;
  club_fecha_fundacion: Date | null;
  club_anio_membresia: number | null;
  federacion: FederacionJSON;
}

export class Club {
  protected constructor(
    private id: string | null,
    private nombre: string,
    private direccion: string,
    private proid: number,
    private localidad: string,
    private codPostal: string,
    private zona: string,
    private nroTelefono: string,
    private activo: boolean,
    private escudo: string,
    private canidDefault: number,
    private fedid: number,
    private sigla: string | null,
    private website: string | null,
    private fechaFundacion: Date | null,
    private anioMembresia: number | null,
    private federacion: Federacion
  ) {}

  static createFrom(
    id: string | null,
    nombre: string,
    direccion: string,
    proid: number,
    localidad: string,
    codPostal: string,
    zona: string,
    nroTelefono: string,
    activo: boolean,
    escudo: string,
    canidDefault: number,
    fedid: number,
    sigla: string | null,
    website: string | null,
    fechaFundacion: Date | null,
    anioMembresia: number | null,
    federacion: Federacion
  ) {
    return new this(
      id,
      nombre,
      direccion,
      proid,
      localidad,
      codPostal,
      zona,
      nroTelefono,
      activo,
      escudo,
      canidDefault,
      fedid,
      sigla,
      website,
      fechaFundacion,
      anioMembresia,
      federacion
    );
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: Club) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: ClubJSON) {
    return Club.createFrom(
      entity.club_id,
      entity.club_nombre,
      entity.club_direccion,
      entity.club_proid,
      entity.club_localidad,
      entity.club_cod_postal,
      entity.club_zona,
      entity.club_nro_telefono,
      entity.club_activo,
      entity.club_escudo,
      entity.club_cjid_default,
      entity.club_fedid,
      entity.club_sigla,
      entity.club_website,
      entity.club_fecha_fundacion ? new Date(entity.club_fecha_fundacion) : null,
      entity.club_anio_membresia,

      Federacion.fromJSON(entity.federacion)
    );
  }

  toJSON(): ClubJSON {
    return {
      club_id: this.getId(),
      club_nombre: this.getNombre(),
      club_direccion: this.getDireccion(),
      club_proid: this.getProid(),
      club_localidad: this.getLocalidad(),
      club_cod_postal: this.getCodPostal(),
      club_zona: this.getZona(),
      club_nro_telefono: this.getNroTelefono(),
      club_activo: this.getActivo(),
      club_escudo: this.getEscudo(),
      club_cjid_default: this.getCanidDefault(),
      club_fedid: this.getFedid(),
      club_sigla: this.sigla,
      club_website: this.website,
      club_fecha_fundacion: this.fechaFundacion,
      club_anio_membresia: this.anioMembresia,

      federacion: this.getFederacion().toJSON(),
    };
  }

  getSigla = () => this.sigla;
  getWebsite = () => this.website;
  getFechaFundacion = () => this.fechaFundacion;
  getAnioMembresia = () => this.anioMembresia;

  getId(): string | null {
    return this.id;
  }

  getNombre(): string {
    return this.nombre;
  }

  getDireccion(): string {
    return this.direccion;
  }

  getProid(): number {
    return this.proid;
  }

  getLocalidad(): string {
    return this.localidad;
  }

  getCodPostal(): string {
    return this.codPostal;
  }

  getZona(): string {
    return this.zona;
  }

  getNroTelefono(): string {
    return this.nroTelefono;
  }

  getActivo(): any {
    return this.activo;
  }

  getEscudo(): string {
    return this.escudo;
  }

  getCanidDefault(): number {
    return this.canidDefault;
  }

  getFedid(): number {
    return this.fedid;
  }

  getFederacion(): Federacion {
    return this.federacion;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setNombre(value: string): void {
    this.nombre = value;
  }

  setDireccion(value: string): void {
    this.direccion = value;
  }

  setProid(value: number): void {
    this.proid = value;
  }

  setLocalidad(value: string): void {
    this.localidad = value;
  }

  setCodPostal(value: string): void {
    this.codPostal = value;
  }

  setZona(value: string): void {
    this.zona = value;
  }

  setNroTelefono(value: string): void {
    this.nroTelefono = value;
  }

  setActivo(value: any): void {
    this.activo = value;
  }

  setEscudo(value: string): void {
    this.escudo = value;
  }

  setCanidDefault(value: number): void {
    this.canidDefault = value;
  }

  setFedid(value: number): void {
    this.fedid = value;
  }

  setFederacion(value: Federacion): void {
    this.federacion = value;
  }

  nameLike(val: string): boolean {
    if (this.getNombre()) {
      return this.getNombre().toLowerCase().includes(val.toLowerCase());
    } else return true;
  }
}
